export { useGetGoalsConfig } from "./useGetGoalsConfig";
export { useGoalsConfig } from "./useGoalsConfig";
export { useUpdateGoalsConfig } from "./useUpdateGoalsConfig";
